import { ResolveFn } from '@angular/router';
import { isObservable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

const TEST_PREFIX = '[TEST] ';

function prefixTestTitle(title: string): string {
  if (environment.production || title.startsWith(TEST_PREFIX)) {
    return title;
  }

  return `${TEST_PREFIX}${title}`;
}

export function withTestTitlePrefix(resolveFn: ResolveFn<string>): ResolveFn<string> {
  return (route, state) => {
    const result = resolveFn(route, state);

    if (isObservable(result)) {
      return result.pipe(map(title => typeof title === 'string' ? prefixTestTitle(title) : title));
    }

    if (result instanceof Promise) {
      return result.then(title => typeof title === 'string' ? prefixTestTitle(title) : title);
    }

    return typeof result === 'string' ? prefixTestTitle(result) : result;
  };
}
